import { AfterViewInit, ChangeDetectorRef, Component } from '@angular/core';
import { Router } from '@angular/router';
import { environment as env } from 'src/environments/environment';
import { CommonResponse } from '../../../shared/models/reponse.model';
import { LoginService } from '../../services/logIn.service';
import {
  MatSnackBarHorizontalPosition,
  MatSnackBarVerticalPosition,
} from '@angular/material/snack-bar';
import { SnackbarService } from 'src/app/shared/services/snackbar.service';
import { ValidateRoutePermissions } from '../../models/route-permission.auth';
import { LoggedUser } from '../../models/user.auth';
import { PageLoadingService } from 'src/app/shared/services/page-loading.service';
import { ShopCartService } from 'src/app/books/services/shop-cart.service';
import { CountryService } from 'src/app/countries/services/country.service';

@Component({
  selector: 'app-login-form',
  templateUrl: './login-form.component.html',
  styleUrls: ['./login-form.component.scss'],
})
export class LoginFormComponent {
  email: string = '';
  codeSent = false;
  code = '';

  password: string = '';
  twofa_code: string = '';
  showErrorMessages = false;
  countryName: string = '';
  horizontalPosition: MatSnackBarHorizontalPosition = 'right';
  verticalPosition: MatSnackBarVerticalPosition = 'top';
  useTwoFactorAuthentication: boolean = true;

  isAdminUser = false;
  loginStep: 'credentials' | 'code' = 'credentials';

  // private readonly twoFaLoginObserver = {
  //   next: (data: CommonResponse<any>) => this.twoFaLoginNext(data),
  //   error: (error: CommonResponse<any>) => this.twoFaLoginError(error),
  //   complete: () => this._pageLoadingService.hideLoadingGif(),
  // };

  constructor(
    private _snackbarService: SnackbarService,
    private _loginService: LoginService,
    private _router: Router,
    private _countryService: CountryService,
    private cdr: ChangeDetectorRef,
    private _pageLoadingService: PageLoadingService,
    private _shopCartService: ShopCartService,
  ) { }

  ngOnInit() {
    const storedCountryName = localStorage.getItem('countryName');

    if (storedCountryName !== null) {
      if (storedCountryName === 'Japan' || storedCountryName === 'Japón') {
        this.useTwoFactorAuthentication = false;
      }

      this.countryName = storedCountryName;

      this._countryService.getCountryName$().subscribe((countryName) => {
        this.countryName = countryName;
        this.cdr.detectChanges();
      });
    } else {
      this._countryService.getCountryName$().subscribe((countryName) => {
        this.countryName = countryName;
        this.cdr.detectChanges();
      });
    }
  }

  isInvalidEmail() {
    const regExValidator = /^[a-zA-Z0-9+_.-]+@[a-zA-Z0-9.-]+$/;
    return !regExValidator.test(this.email);
  }

  isPasswordRequired(): boolean {
    return this.isAdminUser;
  }

  isCodeRequired(): boolean {
    return this.loginStep === 'code';
  }

  isPasswordInvalid(): boolean {
    return (
      this.isAdminUser &&
      this.password.length < env.password_min_length
    );
  }

  isCodeInvalid(): boolean {
    if (!this.isCodeRequired()) return false;
    return this.twofa_code.length < env.code_length;
  }

  handleLogin(): void {
    if (this.loginStep === 'credentials') {
      this.sendLogin();
      return;
    }

    this.verifyCode();
  }

  goBack() {
    this.loginStep = 'credentials';
  }

  sendLogin() {

    if (this.isInvalidEmail()) {
      this.showErrorMessages = true;
      return;
    }

    this._pageLoadingService.showLoadingGif();

    this._loginService.sendEmailCode(this.email)
      .subscribe({
        next: (response: any) => {

          this.isAdminUser =
            response.isAdmin ??
            response.body?.isAdmin ??
            false;

          this.loginStep = 'code';

          this._pageLoadingService.hideLoadingGif();
        },
        error: (error) => {
          this._pageLoadingService.hideLoadingGif();
          console.error(error);
        }
      });
  }

  sendCode() {
    if (this.isInvalidEmail()) {
      this.showErrorMessages = true;
      return;
    }

    this._pageLoadingService.showLoadingGif();

    this._loginService.sendEmailCode(this.email).subscribe({
      next: (response: any) => {
        this.codeSent = true;

        this.isAdminUser = response.body?.isAdmin ?? false;

        this._pageLoadingService.hideLoadingGif();
      },
      error: (error) => {
        this._pageLoadingService.hideLoadingGif();

        console.error(error);
      },
    });
  }

  verifyCode(): void {
    const codeValid =
      this.twofa_code?.length >= env.code_length;

    const passwordValid =
      !this.isAdminUser ||
      this.password?.length >= env.password_min_length;

    if (!codeValid || !passwordValid) {
      this.showErrorMessages = true;
      return;
    }

    this.loginWithCode();
  }

  loginWithCode(): void {

    if (this.isInvalidEmail()) {
      this.showErrorMessages = true;
      return;
    }

    this._pageLoadingService.showLoadingGif();

    this._loginService.authDesktopWithCode(this.email, this.twofa_code, this.password, this._shopCartService.getCartProductsIdsFromLocal()).subscribe({
      next: (response: any) => {

        this._pageLoadingService.hideLoadingGif();

        const user = response.data.user;

        const route = ValidateRoutePermissions.getDefaultUrlForUser(user);

        this._router.navigate(route || []);
      },
      error: (error) => {

        this._pageLoadingService.hideLoadingGif();

        switch (error.statusCode) {

          case 401:
            this._snackbarService.openStandardSnackBar(
              'incorrectCredentials'
            );
            break;

          case 400:
            this._snackbarService.openStandardSnackBar(
              'incorrectEmailOrCode'
            );
            break;

          default:
            this._snackbarService.openStandardSnackBar(
              'defaultErrorMessage'
            );
            break;
        }

        console.error(error);
      }
    });
  }

  // twoFaLoginNext(data: CommonResponse<any>) {
  //   this._router.navigate(
  //     ValidateRoutePermissions.getDefaultUrlForUser(
  //       data.data.user as LoggedUser,
  //     ) || [],
  //   );
  // }

  // twoFaLoginError(error: CommonResponse<any>) {
  //   this._pageLoadingService.hideLoadingGif();
  //   this._snackbarService.openStandardSnackBar(error.message);
  // }

  // twoFaLogin() {
  //   const emailValid = !this.isInvalidEmail();
  //   const passwordValid = this.isAdminUser ? !this.isPasswordInvalid() : true;
  //   const codeValid = this.twofa_code.length >= env.code_length;

  //   if (emailValid && codeValid && passwordValid) {

  //     this._pageLoadingService.showLoadingGif();

  //     this._loginService.twoFaLogin(
  //       this.email,
  //       this.password,
  //       this.twofa_code,
  //       this._shopCartService.getCartProductsIdsFromLocal()
  //     ).subscribe(this.twoFaLoginObserver);

  //   } else {
  //     this.showErrorMessages = true;
  //   }
  // }
}
